import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'

/**
 * @function getUcaseTabs 获取案件详情的 tab
 * @param {Number} id 案件 id
 * @returns {Array} tabList
 */
const getYPsame = (query) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/reports/order/group?${query}`
    )
    .then(checkResponse)
}

export{
  getYPsame
}
